import { useCallback, useMemo } from 'react';
import { TCities, TCitiesSelectorUseDataProps } from '../../../utils/types';

export function useData({ options, searchValue, loadedItems, setLoadedItems }: TCitiesSelectorUseDataProps) {
  const filteredOptions = useMemo(() => {
    return options.filter((option: TCities) => option.name.toLowerCase().startsWith(searchValue.toLowerCase()));
  }, [options, searchValue]);

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget as HTMLDivElement;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 500) {
        const nextPage = loadedItems.length / 50 + 1;
        const startIndex = (nextPage - 1) * 50;
        const endIndex = Math.min(startIndex + 50, filteredOptions.length);
        const newItems = filteredOptions.slice(startIndex, endIndex);

        if (newItems.length > 0) {
          setLoadedItems((prevItems: TCities[]) => [...prevItems, ...newItems]);
        }
      }
    },
    [filteredOptions, loadedItems, setLoadedItems],
  );

  return { filteredOptions, handleScroll };
}
